import {
  RegistrationWaitlistOutcomeStatusStrategy,
  RegistrationWaitlistOutcomeStatusConditionalStrategy,
  IRegistrationWaitlistOutcomeStatusContext,
  OUTCOME_STATUS_TYPES
} from '../strategies/registration_waitlist_outcome_status_strategy';
import { IPusherOutcome, IRegistrationWaitlistPusherOutcome } from '../../../interfaces/scheduler_interfaces';

import * as _4 from 'lodash4';

export class RegisterWaitlistOutcomeFilters {
  getFiltered(
    pusherOutcome: IRegistrationWaitlistOutcomeStatusContext[],
    outcomeTypeToFilterBy: OUTCOME_STATUS_TYPES
  ): any[] {
    return _4.filter(pusherOutcome, (pusherOutc: IRegistrationWaitlistOutcomeStatusContext) => {
      const outcomeType = RegistrationWaitlistOutcomeStatusStrategy.getByKey(
        RegistrationWaitlistOutcomeStatusConditionalStrategy.evaluate(pusherOutc)
      );
      return _4.isEqual(outcomeTypeToFilterBy, outcomeType.name);
    });
  }
}

angular.module('capability-ng-scheduler').service('ngRegisterWaitlistOutcomeFilters', RegisterWaitlistOutcomeFilters);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/filters/register_waitlist_filters.ts